import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';

import { ConversationItem } from './components';
import theme from './ConversationsTab.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  conversationItems: PropTypes.arrayOf(
    PropTypes.shape({
      start: PropTypes.number.isRequired,
      end: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired,
      status: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

const defaultProps = {};

const ConversationsTab = ({ style, intl, conversationItems }) => {
  const conversations = conversationItems
    .filter(item => item.status !== 'CREATED' && item.status !== 'FAILED' && item.status);

  return (
    <div
      style={ style }
      className={ theme.root }
    >
      <div className={ theme.main }>
        { map(conversations, item => (
          <ConversationItem
            key={ `conversation-item-${ item.conversationId }` }
            { ...{ ...item, intl } }
          />
        )) }
      </div>
    </div>
  );
};

ConversationsTab.propTypes = propTypes;
ConversationsTab.defaultProps = defaultProps;

export default ConversationsTab;
